import { render, staticRenderFns } from "./ManageAssignations.vue?vue&type=template&id=b0142916&scoped=true"
import script from "./ManageAssignations.vue?vue&type=script&lang=js"
export * from "./ManageAssignations.vue?vue&type=script&lang=js"
import style0 from "./ManageAssignations.vue?vue&type=style&index=0&id=b0142916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0142916",
  null
  
)

export default component.exports